'use strict';

(function () {
  if (window.__BTF_EXPRESS_BADGE_BOOTED__) return;
  window.__BTF_EXPRESS_BADGE_BOOTED__ = true;

  var STYLE_ID = 'btf-express-badge-style';
  var BADGE_SELECTOR = '[data-btf-express-badge]';
  var CARD_SELECTOR = '[data-btf-card]';
  var COLLECTION_DELIVERY_SELECTOR = '[data-btf-collection-delivery], [data-btf-timer-wrap]';
  var EXPRESS_METHOD = 'express';
  var BADGE_TEXT = '90-minute delivery available';
  var SAME_DAY_TEXT = 'Same-day delivery available';
  var PDP_BADGE_SELECTOR = '#express-badge';
  var utilsCache = null;

  function getUtils() {
    if (utilsCache) return utilsCache;
    if (window.BTFDeliveryUtils) {
      utilsCache = window.BTFDeliveryUtils;
      return utilsCache;
    }
    return null;
  }

  function toText(value) {
    return value === null || value === undefined ? '' : String(value).trim();
  }

  function readJson(value) {
    if (!value) return null;
    if (typeof value === 'object') return value;
    if (typeof value !== 'string') return null;
    var text = value.trim();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (err) {
      return null;
    }
  }

  function getCurrentISTDateString() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());

    var year = '';
    var month = '';
    var day = '';
    parts.forEach(function (part) {
      if (part.type === 'year') year = part.value;
      if (part.type === 'month') month = part.value;
      if (part.type === 'day') day = part.value;
    });

    return year && month && day ? [year, month, day].join('-') : '';
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '[data-btf-express-badge] {',
      '  position: absolute;',
      '  top: 12px;',
      '  right: 12px;',
      '  z-index: 6;',
      '  display: inline-flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  max-width: calc(100% - 24px);',
      '  box-sizing: border-box;',
      '  padding: 8px 12px;',
      '  border-radius: 999px;',
      '  background: rgba(255, 245, 222, 0.96);',
      '  color: #f37a1f;',
      '  font-size: 12px;',
      '  line-height: 1.15;',
      '  font-weight: 600;',
      '  letter-spacing: 0;',
      '  text-align: center;',
      '  pointer-events: none;',
      '  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);',
      '}',
      '[data-btf-express-badge].is-visible { display: inline-flex !important; }',
      '[data-btf-timer-wrap] { display: flex; align-items: center; justify-content: flex-start; flex-wrap: wrap; gap: 4px; }',
      '[data-btf-timer-wrap] [data-btf-timer-prefix] { white-space: nowrap; }',
      '[data-btf-timer-wrap] [data-btf-timer-value] { white-space: nowrap; }',
      '@media (max-width: 749px) {',
      '  [data-btf-express-badge] {',
      '    top: 10px;',
      '    right: 10px;',
      '    padding: 6px 10px;',
      '    font-size: 11px;',
      '  }',
      '  [data-btf-timer-wrap] { align-items: flex-start; line-height: 1.3; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function getCardProductContext(card) {
    if (!card) return null;
    return {
      product_id: toText(card.getAttribute('data-btf-shopify-product-id')),
      shopify_product_id: toText(card.getAttribute('data-btf-shopify-product-id')),
      variant_id: toText(card.getAttribute('data-btf-shopify-variant-id')),
      shopify_variant_id: toText(card.getAttribute('data-btf-shopify-variant-id')),
      sku: toText(card.getAttribute('data-btf-sku')),
      title: toText(card.getAttribute('data-btf-product-title')),
      available: toText(card.getAttribute('data-btf-product-available')) !== 'false'
    };
  }

  function setBadgeVisible(badge, visible, text) {
    if (!badge) return;
    // Express availability is displayed in the card copy, never over the
    // product image. Keep the legacy badge node hidden for compatibility.
    badge.hidden = true;
    badge.style.display = 'none';
    badge.classList.remove('is-visible');
    badge.setAttribute('aria-hidden', 'true');
  }

  function updateCollectionDeliveryCopy(card, eligible, locationContext, productContext, stockState) {
    if (!card) return;

    // Collection cards keep the delivery paragraph beside the image node that
    // carries data-btf-card, so search the complete card item as well.
    var cardRoot = card.closest('li, article, .cpc') || card;
    var delivery = cardRoot.querySelector(COLLECTION_DELIVERY_SELECTOR);
    if (!delivery) return;

    if (!delivery.dataset.btfOriginalHtml) delivery.dataset.btfOriginalHtml = delivery.innerHTML;
    var presentation = getDeliveryPresentation(locationContext, productContext, stockState);
    var expressDeliveryText = toText(card.getAttribute('data-btf-express-delivery-text')) || BADGE_TEXT;
    var showExpressCopy = presentation.express;
    var prefix = delivery.querySelector('[data-btf-timer-prefix]');
    var value = delivery.querySelector('[data-btf-timer-value], [data-btf-collection-delivery-value]');
    if (showExpressCopy) {
      delivery.textContent = expressDeliveryText;
    } else if (prefix && value) {
      prefix.textContent = presentation.prefix;
      value.textContent = presentation.value;
    } else {
      delivery.textContent = presentation.prefix + ' ' + presentation.value;
    }
    delivery.hidden = false;
    delivery.classList.toggle('is-express', presentation.express);
  }

  function updateCardTimer(card, eligible) {
    if (!card) return;
    var timer = card.querySelector('[data-btf-timer]');
    if (!timer) return;
    if (!timer.dataset.btfOriginalHtml) timer.dataset.btfOriginalHtml = timer.innerHTML;

    var utils = getUtils();
    var locationContext = utils && utils.getResolvedDeliveryLocationContext
      ? utils.getResolvedDeliveryLocationContext() : null;
    var presentation = getDeliveryPresentation(locationContext, getCardProductContext(card),
      utils && utils.getCardStockAvailabilityState
        ? utils.getCardStockAvailabilityState(readJson(card.getAttribute('data-btf-stock'))) : null);
    timer.textContent = presentation.express
      ? (toText(card.getAttribute('data-btf-express-delivery-text')) || BADGE_TEXT)
      : presentation.prefix + ' ' + presentation.value;
    timer.hidden = false;
    timer.style.display = 'block';
    timer.classList.toggle('is-express', presentation.express);
  }

  function updateAllCardTimers(eligibleCards) {
    var timers = document.querySelectorAll('[data-btf-timer]');
    if (!timers.length) return;

    timers.forEach(function (timer) {
      var card = timer.closest(CARD_SELECTOR);
      if (card) return;

      // Support a section-level timer from older home-page templates.
      if (!timer.dataset.btfOriginalHtml) timer.dataset.btfOriginalHtml = timer.innerHTML;
      var showExpress = Boolean(eligibleCards);
      timer.textContent = showExpress ? BADGE_TEXT : SAME_DAY_TEXT;
      timer.hidden = false;
      timer.style.display = 'block';
    });
  }

  function updateAllDeliveryTimers() {
    var utils = getUtils();
    if (!utils) return;
    var locationContext = utils.getResolvedDeliveryLocationContext();
    document.querySelectorAll('[data-btf-timer-wrap]').forEach(function (wrap) {
      var root = wrap.closest('[data-btf-card], li, article') || wrap;
      var card = root.matches && root.matches('[data-btf-card]') ? root : root.querySelector('[data-btf-card]');
      var productContext = card ? getCardProductContext(card)
        : (root.getAttribute && root.getAttribute('data-btf-shopify-product-id') ? getCardProductContext(root)
        : (utils.getCurrentProductContext ? utils.getCurrentProductContext() : null));
      var stockState = card && utils.getCardStockAvailabilityState
        ? utils.getCardStockAvailabilityState(readJson(card.getAttribute('data-btf-stock'))) : null;
      var presentation = getDeliveryPresentation(locationContext, productContext, stockState);
      var prefix = wrap.querySelector('[data-btf-timer-prefix]');
      var value = wrap.querySelector('[data-btf-timer-value]');
      if (presentation.express) {
        wrap.textContent = BADGE_TEXT;
      } else {
        if (prefix) prefix.textContent = presentation.prefix;
        if (value) value.textContent = presentation.value;
      }
      wrap.hidden = false;
      wrap.style.display = '';
      wrap.classList.toggle('is-express', presentation.express);
    });
  }

  function pincodeRuleAllows(rule, pin) {
    var value = rule;
    var textPin = toText(pin);
    if (!value || !textPin) return null;
    if (typeof value === 'boolean') return value;
    if (Array.isArray(value)) {
      return value.some(function (entry) {
        return pincodeRuleAllows(entry, textPin) === true;
      });
    }
    if (typeof value === 'string' || typeof value === 'number') {
      return toText(value) === textPin;
    }

    var ruleObject = readJson(value) || value;
    if (!ruleObject || typeof ruleObject !== 'object') return null;
    if (ruleObject.enabled === false || ruleObject.active === false) return false;

    var excluded = Array.isArray(ruleObject.exclude) ? ruleObject.exclude.map(toText) : [];
    var included = Array.isArray(ruleObject.include) ? ruleObject.include.map(toText) : [];
    if (excluded.indexOf(textPin) !== -1) return false;
    if (included.indexOf(textPin) !== -1) return true;

    var ranges = Array.isArray(ruleObject.ranges) ? ruleObject.ranges : [];
    if (ranges.some(function (range) {
      return Array.isArray(range) && Number(textPin) >= Number(range[0]) && Number(textPin) <= Number(range[1]);
    })) return true;

    var prefixes = Array.isArray(ruleObject.prefixes) ? ruleObject.prefixes : [];
    if (prefixes.some(function (prefix) { return textPin.indexOf(toText(prefix)) === 0; })) return true;
    if (included.length || excluded.length || ranges.length || prefixes.length) return false;
    return ruleObject.enabled !== undefined ? ruleObject.enabled !== false : null;
  }

  function getExpressEligibilityDetails(locationContext, productContext, stockState) {
    var utils = getUtils();
    var locationData = locationContext ? locationContext.location : null;
    var pin = locationContext && locationContext.pin;
    var methodState = locationData && utils
      ? utils.getLocationMethodState(locationData, EXPRESS_METHOD, productContext)
      : null;
    var explicitlyAllowed = Boolean(locationData && utils && typeof utils.isProductSpecificallyAllowed === 'function'
      && utils.isProductSpecificallyAllowed(locationData, EXPRESS_METHOD, productContext));
    var productAllowed = Boolean(locationData && utils && typeof utils.isMethodAllowedForProduct === 'function'
      && utils.isMethodAllowedForProduct(locationData, EXPRESS_METHOD, productContext));
    var pincodeRule = locationData && utils && typeof utils.getMethodPincodeRule === 'function'
      ? utils.getMethodPincodeRule(locationData, EXPRESS_METHOD)
      : null;
    var hasPincode = toText(pin).length === 6;
    var pincodeState = hasPincode && pincodeRule && utils && typeof utils.resolvePincodeRuleState === 'function'
      ? utils.resolvePincodeRuleState(pincodeRule, pin)
      : null;
    var directPincodeState = hasPincode ? pincodeRuleAllows(pincodeRule, pin) : null;
    var today = getCurrentISTDateString();

    if (!utils || !locationData || !methodState) return { eligible: false, reason: 'missing-location-or-method' };
    if (stockState && stockState.has_stock && stockState.is_available === false) {
      return { eligible: false, reason: 'out-of-stock', explicitlyAllowed: explicitlyAllowed };
    }
    if (!productAllowed && !explicitlyAllowed) return { eligible: false, reason: 'product-not-allowed' };
    if (hasPincode && (directPincodeState === false || (directPincodeState === null && pincodeState === false))) {
      return { eligible: false, reason: 'pincode-not-allowed', explicitlyAllowed: explicitlyAllowed, pincodeState: pincodeState };
    }
    // A product allowlist is intentionally allowed to override location.methods.express=false.
    // The location and pincode checks above still apply, so express remains branch-scoped.
    // A matching location product rule is the authoritative express opt-in.
    // `location.methods.express` can remain false as the global default while
    // selected products are still explicitly enabled for express delivery.
    if (methodState.enabled === false && !explicitlyAllowed) {
      return { eligible: false, reason: 'method-disabled', explicitlyAllowed: explicitlyAllowed };
    }
    if (!utils.isMethodAllowedOnSpecialDate(locationData, EXPRESS_METHOD, today)) {
      return { eligible: false, reason: 'special-date-disabled', explicitlyAllowed: explicitlyAllowed };
    }
    if (utils.isBeforeTime(methodState.effective_start_time)) {
      return { eligible: false, reason: 'before-start-time', explicitlyAllowed: explicitlyAllowed };
    }
    if (utils.isAfterCutoff(methodState.effective_cutoff_time)) {
      return { eligible: false, reason: 'after-cutoff', explicitlyAllowed: explicitlyAllowed };
    }
    return {
      eligible: true,
      reason: 'eligible',
      explicitlyAllowed: explicitlyAllowed,
      productAllowed: productAllowed,
      pincodeState: pincodeState,
      directPincodeState: directPincodeState
    };
  }

  function hasAvailableFixedSlotToday(locationContext, productContext) {
    var utils = getUtils();
    var location = locationContext && locationContext.location;
    var config = utils && utils.getConfig ? (utils.getConfig() || {}) : {};
    var slotCodes = location && location.slots && location.slots.fixed_time;
    if (!utils || !location || !Array.isArray(slotCodes)) return false;

    var methodState = utils.getLocationMethodState
      ? utils.getLocationMethodState(location, 'fixed_time', productContext) : null;
    if (methodState && methodState.enabled === false) return false;

    var nowParts = utils.getCurrentTimeISTParts ? utils.getCurrentTimeISTParts() : { totalSecs: 0 };
    var nowMinutes = Math.floor(nowParts.totalSecs / 60);

    return slotCodes.some(function (slotCode) {
      var globalSlot = config.slots && config.slots[slotCode];
      var slotState = utils.getLocationSlotState
        ? utils.getLocationSlotState(location, 'fixed_time', slotCode) : null;
      if (!globalSlot && !slotState) return false;
      if (slotState && slotState.enabled === false) return false;

      var startTime = slotState && (slotState.effective_start_time || slotState.start);
      var cutoffTime = slotState && (slotState.effective_cutoff_time || slotState.cutoff_time);
      startTime = startTime || (globalSlot && globalSlot.start);
      cutoffTime = cutoffTime || (globalSlot && globalSlot.cutoff_time);
      var start = utils.parseTimeToMinutes ? utils.parseTimeToMinutes(startTime) : null;
      var cutoff = utils.parseTimeToMinutes ? utils.parseTimeToMinutes(cutoffTime) : null;
      if (start !== null && nowMinutes < start) return true;
      return cutoff === null || nowMinutes < cutoff;
    });
  }

  function getDeliveryPresentation(locationContext, productContext, stockState) {
    var utils = getUtils();
    if (!utils || !locationContext || !locationContext.location) {
      return { prefix: 'Earliest Delivery:', value: 'Select pincode', express: false };
    }
    var eligibility = getExpressEligibilityDetails(locationContext, productContext, stockState);
    var methodState = utils.getLocationMethodState(locationContext.location, EXPRESS_METHOD, productContext) || {};
    var pinRule = utils.getMethodPincodeRule ? utils.getMethodPincodeRule(locationContext.location, EXPRESS_METHOD) : null;
    var pinState = pinRule && locationContext.pin && utils.resolvePincodeRuleState
      ? utils.resolvePincodeRuleState(pinRule, locationContext.pin) : null;
    if (!productContext) {
      eligibility.eligible = methodState.enabled !== false && pinState !== false
        && (!utils.isMethodAllowedOnSpecialDate || utils.isMethodAllowedOnSpecialDate(locationContext.location, EXPRESS_METHOD, new Date().toISOString()));
    }
    var sameDayAvailable = eligibility.eligible || eligibility.reason === 'before-start-time';
    // The Express pincode rule controls P1 (90-minute) eligibility only.
    // The header/countdown can still confirm P2 same-day delivery for the
    // location, so an Express pincode mismatch must not force Tomorrow.
    var sameDayMethodState = utils.getLocationMethodState
      ? (utils.getLocationMethodState(locationContext.location, 'fixed_time', productContext)
        || utils.getLocationMethodState(locationContext.location, 'standard', productContext))
      : null;
    var locationHasFinalCutoff = Boolean(
      locationContext.location.final_cutoff_time || locationContext.location.final_cutoff_label
    );
    var locationSameDayAvailable = (locationHasFinalCutoff || (sameDayMethodState && sameDayMethodState.enabled !== false))
      && (!utils.isMethodAllowedOnSpecialDate
        || utils.isMethodAllowedOnSpecialDate(locationContext.location, 'fixed_time', new Date().toISOString()));
    if (stockState && stockState.has_stock && stockState.is_available === false) {
      locationSameDayAvailable = false;
    }
    sameDayAvailable = sameDayAvailable || locationSameDayAvailable;
    var nowParts = utils.getCurrentTimeISTParts ? utils.getCurrentTimeISTParts() : { totalSecs: 0 };
    var nowMinutes = Math.floor(nowParts.totalSecs / 60);
    var expressCutoff = utils.parseTimeToMinutes
      ? utils.parseTimeToMinutes(methodState.effective_cutoff_time)
      : null;
    var locationFinalCutoff = locationContext.location.final_cutoff_time
      || locationContext.location.final_cutoff_label
      || null;
    var sameDayCutoff = utils.parseTimeToMinutes
      ? utils.parseTimeToMinutes(locationFinalCutoff)
      : null;
    // P1 (90-minute) ends at the Express cutoff. P2 (same-day) remains
    // available until the location's final cutoff from the Price Engine.
    if (sameDayCutoff === null) sameDayCutoff = expressCutoff;

    // Priority order: 90-minute delivery (P1), same-day delivery (P2),
    // then the next available day (P3). Before the configured start time,
    // same-day is still today's delivery option; the start time controls
    // when the countdown/90-minute option becomes active, not the date.
    var expressStillAvailable = eligibility.eligible
      && (expressCutoff === null || nowMinutes < expressCutoff);
    var sameDayStillAvailable = sameDayAvailable
      && (sameDayCutoff === null || nowMinutes < sameDayCutoff);
    if (expressStillAvailable) {
      return {
        prefix: 'Earliest Delivery:',
        value: 'Today',
        express: true
      };
    }

    if (sameDayStillAvailable) {
      return {
        prefix: 'Earliest Delivery:',
        value: 'Today',
        express: false
      };
    }

    if (hasAvailableFixedSlotToday(locationContext, productContext)) {
      return {
        prefix: 'Earliest Delivery:',
        value: 'Today',
        express: false,
        reason: 'fixed-time-slot-available'
      };
    }

    var nextDate = utils.getNextAvailableDeliveryDate
      ? utils.getNextAvailableDeliveryDate(locationContext.location, 'standard') : null;
    return {
      prefix: 'Earliest Delivery:',
      value: utils.formatDeliveryDate && nextDate ? utils.formatDeliveryDate(nextDate) : 'Tomorrow',
      express: false,
      reason: eligibility.reason
    };
  }

  function isExpressEligibleForContext(locationContext, productContext, stockState) {
    return getExpressEligibilityDetails(locationContext, productContext, stockState).eligible;
  }

  function updateCardBadge(card) {
    if (!card) return false;

    var utils = getUtils();
    if (!utils) return false;

    var badge = card.querySelector(BADGE_SELECTOR);

    var locationContext = utils.getResolvedDeliveryLocationContext();
    var stockState = utils.getCardStockAvailabilityState(readJson(card.getAttribute('data-btf-stock')));
    var productContext = getCardProductContext(card);
    if (productContext && productContext.available === false) {
      setBadgeVisible(badge, false, BADGE_TEXT);
      updateCollectionDeliveryCopy(card, false, null, productContext, stockState);
      updateCardTimer(card, false);
      return false;
    }
    var eligibility = getExpressEligibilityDetails(locationContext, productContext, stockState);
    var eligible = eligibility.eligible;

    setBadgeVisible(badge, eligible, BADGE_TEXT);
    updateCollectionDeliveryCopy(card, eligible, locationContext, productContext, stockState);
    updateCardTimer(card, eligible);
    card.setAttribute('data-btf-express-eligible', eligible ? 'true' : 'false');
    card.setAttribute('data-btf-express-reason', eligibility.reason || 'unknown');
    return eligible;
  }

  function updatePdpExpressBadge() {
    var utils = getUtils();
    if (!utils) return;

    var badge = document.querySelector(PDP_BADGE_SELECTOR);
    if (!badge) return;

    var locationContext = utils.getResolvedDeliveryLocationContext();
    var productContext = utils.getCurrentProductContext();
    var stockState = utils.getProductStockAvailabilityState();
    if (window.BTF_CURRENT_PRODUCT && window.BTF_CURRENT_PRODUCT.available === false) {
      return;
    }
    var eligibility = getExpressEligibilityDetails(locationContext, productContext, stockState);
    var eligible = eligibility.eligible;
    badge.textContent = BADGE_TEXT;
    badge.setAttribute('data-btf-original-text', BADGE_TEXT);
    badge.hidden = !eligible;
    badge.style.display = eligible ? '' : 'none';
    badge.setAttribute('data-btf-express-reason', eligibility.reason || 'unknown');
  }

  function updateAllBadges() {
    var utils = getUtils();
    if (!utils) return;

    ensureStyle();

    var anyEligible = false;
    document.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      if (updateCardBadge(card)) anyEligible = true;
    });

    updateAllCardTimers(anyEligible);
    updateAllDeliveryTimers();

    updatePdpExpressBadge();
  }

  var refreshTimer = null;
  function scheduleRefresh() {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      refreshTimer = null;
      updateAllBadges();
    }, 60);
  }

  function bootWhenReady() {
    if (!getUtils()) {
      window.setTimeout(bootWhenReady, 50);
      return;
    }

    scheduleRefresh();
    window.setTimeout(scheduleRefresh, 250);
    window.setTimeout(scheduleRefresh, 1000);
  }

  function refresh() {
    scheduleRefresh();
  }

  function debug() {
    var utils = getUtils();
    var locationContext = utils && utils.getResolvedDeliveryLocationContext
      ? utils.getResolvedDeliveryLocationContext()
      : null;
    var cards = Array.prototype.slice.call(document.querySelectorAll(CARD_SELECTOR)).map(function (card) {
      var productContext = getCardProductContext(card);
      var stockState = utils && utils.getCardStockAvailabilityState
        ? utils.getCardStockAvailabilityState(readJson(card.getAttribute('data-btf-stock')))
        : null;
      var result = getExpressEligibilityDetails(locationContext, productContext, stockState);
      return {
        product_id: productContext && productContext.product_id,
        title: productContext && productContext.title,
        result: result,
        badge_visible: Boolean(card.querySelector(BADGE_SELECTOR) && !card.querySelector(BADGE_SELECTOR).hidden),
        badge_reason: result.reason,
        stock: stockState,
        method_state: utils && utils.getLocationMethodState
          ? utils.getLocationMethodState(locationContext && locationContext.location, EXPRESS_METHOD, productContext)
          : null
      };
    });
    return { locationContext: locationContext, cards: cards };
  }

  window.BTFExpressBadgeHelper = {
    refresh: refresh,
    updateAllBadges: updateAllBadges,
    debug: debug,
    getEligibility: function (productContext, stockState) {
      var utils = getUtils();
      var context = utils && utils.getResolvedDeliveryLocationContext
        ? utils.getResolvedDeliveryLocationContext()
        : null;
      return getExpressEligibilityDetails(context, productContext || null, stockState || null);
    },
    getDeliveryPresentation: function (productContext, stockState) {
      var utils = getUtils();
      var context = utils && utils.getResolvedDeliveryLocationContext
        ? utils.getResolvedDeliveryLocationContext() : null;
      return getDeliveryPresentation(context, productContext || null, stockState || null);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWhenReady, { once: true });
  } else {
    bootWhenReady();
  }

  window.addEventListener('load', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('btf:pincode:changed', refresh);
  document.addEventListener('btf:delivery:changed', refresh);
  document.addEventListener('shopify:section:load', refresh);

  if (window.MutationObserver && document.body) {
    var observer = new MutationObserver(function (mutations) {
      var changed = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches(CARD_SELECTOR) || node.querySelector(BADGE_SELECTOR));
        });
      });
      if (changed) scheduleRefresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
